import "./style.css"
const TimeLineLoaderMain = () => {
    return (
        <div className="timeLineLoaderMain w-[100%] flex flex-col-reverse my1200px:flex-row gap-6 animate-pulse">
            {/* Left: Timeline Accordion */}
            <div className="timeLineLoaderMain_leftMainCon rounded-lg shadow-sm w-full my1200px:w-2/3 p-4 space-y-6">
                {Array.from({ length: 6 }).map((_, i) => (
                    <div key={i} className='space-y-6'>
                        <div className="flex items-start space-x-4 ">
                            {/* Icon */}
                            <div className="timeLineLoaderMain_leftMainCon_icon w-5 h-5 rounded-full mt-1" />
                            {/* Label & Line */}
                            <div className="flex-1 mt-1">
                                <div className="timeLineLoaderMain_leftMainCon_label_line h-4 rounded w-24" />
                            </div>
                            {/* Status */}
                            <div className="timeLineLoaderMain_leftMainCon_status h-6 w-24 rounded ml-auto" />
                        </div>
                        <div className="timeLineLoaderMain_leftMainCon_hr rounded w-[95%] ml-[22px]" />
                    </div>
                ))}
            </div>

            {/* Right: Info Panel */}
            <div className="timeLineLoaderMain_rightMainCon w-full my1200px:w-1/3 space-y-6">

                {/* Desktop Course Details Card */}
                <div className="timeLineLoaderMain_rightMainCon_1 rounded-lg shadow-sm p-4 space-y-4 hidden my1200px:block">
                    <div className="flex items-center justify-between">
                        <div className="h-4 timeLineLoaderMain_rightMainCon_2 w-3/4 rounded" />
                        <div className="h-5 w-5 timeLineLoaderMain_rightMainCon_3 rounded-full"></div>

                    </div>
                    {/* <div className="h-4 bg-gray-300 w-3/4 rounded" /> */}

                    <div className="w-full h-[172px] timeLineLoaderMain_rightMainCon_4 rounded-md" />
                    <div className="h-4 timeLineLoaderMain_rightMainCon_5 w-3/4 rounded" />
                    <div className="h-6 w-24 timeLineLoaderMain_rightMainCon_6 rounded" />
                </div>


                {/* Mobile Course Details Card */}
                <div className="timeLineLoaderMain_courseCard_mobile rounded-[0px] my500px:rounded-xl shadow-md p-6 animate-pulse w-full max-w-5xl !mt-[0px] block my1200px:hidden">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                        <div className="h-6 w-32 timeLineLoaderMain_courseCard_mobile_1 rounded"></div>
                        <div className="h-6 w-6 timeLineLoaderMain_courseCard_mobile_2 rounded-full"></div>
                    </div>

                    {/* Content */}
                    <div className="flex items-center space-x-6">
                        {/* Course Image */}
                        <div className="w-[120px] h-[120px] my500px:w-[150px] my500px:h-[150px] timeLineLoaderMain_courseCard_mobile_3 rounded-xl"></div>

                        {/* Course Info */}
                        <div className="flex-1 space-y-4">
                            <div className="h-6 w-3/4 timeLineLoaderMain_courseCard_mobile_4 rounded"></div>
                            <div className="h-7 w-2/4 timeLineLoaderMain_courseCard_mobile_5 rounded-md"></div>
                        </div>
                    </div>
                </div>


                {/* Exam Unlock Card */}
                <div className="timeLineLoaderMain_examCard rounded-lg shadow-sm p-4 space-y-4">
                    <div className="h-4 w-2/3 timeLineLoaderMain_examCard_1 rounded" />
                    <div className="h-4 w-full timeLineLoaderMain_examCard_2 rounded" />
                    <div className="h-8 w-full timeLineLoaderMain_examCard_3 rounded" />
                </div>
            </div>
        </div>
    );
};

export default TimeLineLoaderMain;
